import React from "react";
import { ReactComponent as PictoChallenge } from "../../assets/svg/challenge.svg";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Button, Modal, Form, Alert } from "react-bootstrap";
import Select from "react-select";
const ChallengesTypeModal = ({
  handleClose,
  show,
  challengeType,
  errorMessage,
  handleChallengeTypeChange,
  addOrUpdateChallengeType,
  action,
  brandList,
  valueBrand,
  setBrand,
}) => {
  const [formData] = React.useState({
    name: challengeType.name || "",
    colorInput: challengeType.color || "",
    brand: valueBrand || "",
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });
  const handleInputChange = (e, indexOrName = "") => {
    if (indexOrName === "brand") {
      setNewFormData({
        ...newFormData,
        brand: e,
      });
    } else {
      setNewFormData({
        ...newFormData,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  return (
    <>
      <Modal
        show={show}
        size="lg"
        onHide={() => handleModalHide()}
        centered
        className="w-100"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={(e) => addOrUpdateChallengeType(e)}>
          <Modal.Body className="have-border-top">
            <div className="row ">
              <div className="col-md-6">
                <Form.Group controlId="new-challenge">
                  <Form.Label className="pb-1">Nom Challenge</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nom"
                    autoFocus
                    required
                    value={challengeType.name}
                    name="name"
                    onChange={(e) => {
                      handleInputChange(e);
                      handleChallengeTypeChange(e, "name");
                    }}
                  />
                </Form.Group>
                {errorMessage && (
                  <div className="col-md-12 mt-3 text-center">
                    <Alert variant="danger" className="m-0">
                      {errorMessage}
                    </Alert>
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <Form.Group controlId="new-color">
                  <Form.Label className="pb-1">Couleur Challenge</Form.Label>
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <span>
                        <PictoChallenge
                          className="sidebarIcon ms-3"
                          alt="Challenge"
                          style={{
                            width: 24,
                            height: 24,
                            fill: challengeType.color,
                          }}
                        />
                      </span>
                    </div>
                    <div className="col-md-4">
                      <Form.Control
                        type="text"
                        placeholder="#a82424"
                        autoFocus
                        required
                        pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$"
                        title="Le code hexadécimal doit être de 6 caractères et avec # devant, ex : #a82424"
                        value={challengeType.color}
                        name="colorInput"
                        onChange={(e) => {
                          handleInputChange(e);
                          handleChallengeTypeChange(e, "color");
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <Form.Group
                        controlId="color"
                        className="row align-items-center"
                      >
                        <Form.Label className="col-md-6">
                          <SearchOutlinedIcon />
                        </Form.Label>
                        <Form.Control
                          type="color"
                          required
                          className="col-md-6"
                          value={challengeType.color}
                          name="colorInput"
                          onChange={(e) => {
                            handleInputChange(e);
                            handleChallengeTypeChange(e, "color");
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-12 mt-5 mb-3">
                <Select
                  placeholder="Choisir une marque"
                  required
                  isDisabled={
                    action.includes("Modifier Challenge") ? true : false
                  }
                  value={valueBrand}
                  name="brand"
                  onChange={(e) => {
                    handleInputChange(e, "brand");
                    setBrand(e);
                  }}
                  options={brandList}
                  className="black border-white"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="is-bottom-right">
            <Button variant="secondary" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="success" type="submit">
              valider
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ChallengesTypeModal;
